module.exports = __webpack_public_path__ + "static/img/posnode-logo-qian.8e0017b.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/svg/posnode-logo-qian.svg
// module id = 7i6S
// module chunks = 1